import React, {PureComponent} from "react"

import Select, {SelectValueType} from "@irati/ui/src/FormItem/Select"
import {injectIntl, InjectIntl} from "@irati/utils/lang"

interface Option {
  value: string
  label: string
}

interface Props extends InjectIntl {
  value: SelectValueType
  onChange: (value: string) => void
  options: Option[]
}

class Teams extends PureComponent<Props> {
  render() {
    const {formatMessage, value, options, ...props} = this.props

    return (
      <Select
        isMulti
        name="team"
        id="select_team"
        label={formatMessage({id: "platform.fields.teams.optionalLabel"})}
        placeholder={formatMessage({id: "platform.fields.teams.placeholder"})}
        value={value}
        options={options}
        {...props}
      />
    )
  }
}

export default injectIntl(Teams)
